import VehicleClosest from "./classes/vehicleClosest";
import VehicleDetection from "./classes/vehicleDetection";
import VehicleQuality from "./classes/vehicleQuality";
import { Errors } from "./utils/errors";
import { rotate } from "./utils/utils";



export class VehicleVerification {
    constructor() {
        return (async () => {
            this.config = await this.loadConfig();
            this.vehicle_closest =  new VehicleClosest();
            this.quality_detection = await new VehicleQuality();
            this.vehicle_detection = await new VehicleDetection();
            this.hasError = false;
            this.errorMessage = "";
            return this;
        })();
    }

    async loadConfig(){
        return fetch("./config/config.json").then((res)=>{
            return res.json();
        }).then((data)=>{
            return data;
        }).catch((err)=>{
            console.error(err)
        });

    }
    areModelsLoaded() {
        return this.vehicle_detection.checkModelisLoaded() &&  this.quality_detection.checkModelisLoaded();
    }
    async processResult(
        image,
        rotation=0,
        vehicleType=null,
        letTestData=false,
    ) {
        let result = {}
        window.tf.engine().startScope();
        this.hasError=false;
        this.errorMessage="";
        let res = [];
        if (rotation != 0){
            image = rotate(image,rotation)
        }
        let [vehicles,det_has_error,det_error] = await this.vehicle_detection.detect(image);
        this.hasError=det_has_error;
        this.errorMessage = det_error;
        if(!this.hasError){
            let vehicle_image = null;
            let closest = null;
            if(vehicleType==null){
                let min_distance = -Infinity;
                let closest_vehicle = null;
                vehicles.forEach((item)=>{
                    const [x1,y1,x2,y2,det_score,obj_class] = item.boxes;
                    const [closest_,finded_ratio] = this.vehicle_closest.isClose([x1,y1,x2,y2],image.width,image.height,this.config["THRESHOLDS"]["CLOSEST_THRESHOLD"]);
                    if (finded_ratio >= min_distance){
                        min_distance = finded_ratio;
                        closest_vehicle = item;
                        closest = closest_;
                    }
                });
                vehicle_image = closest_vehicle.vehicle;
                if(this.config[closest_vehicle.boxes[5].toString()] == "motorcycle"){
                    vehicleType = "motorcycle";
                }else{
                    vehicleType = "car";
                }
            }else if(vehicleType == "car"){
                let min_distance = -Infinity;
                let closest_vehicle = null;
                vehicles.forEach((item)=>{
                    const [x1,y1,x2,y2,det_score,obj_class] = item.boxes;
                    if (this.config["CLASSES"][obj_class.toString()] == "motorcycle"){
                        return;
                    }
                    const [closest_,finded_ratio] = this.vehicle_closest.isClose([x1,y1,x2,y2],image.width,image.height,this.config["THRESHOLDS"]["CLOSEST_THRESHOLD"]);
                    if (finded_ratio >= min_distance){
                        min_distance = finded_ratio;
                        closest_vehicle = item;
                        closest = closest_;
                    }
                });
                if (closest_vehicle != null){
                    vehicle_image = closest_vehicle.vehicle;
                }else{
                    this.hasError = true;
                    this.errorMessage = Errors.getMessage(Errors.NO_CAR);
                }
            }else if(vehicleType == "motorcycle"){
                let min_distance = -Infinity;
                let closest_vehicle = null;
                vehicles.forEach((item)=>{
                    const [x1,y1,x2,y2,det_score,obj_class] = item.boxes;
                    if (this.config["CLASSES"][obj_class.toString()] != "motorcycle"){
                        return;
                    }
                    const [closest_,finded_ratio] = this.vehicle_closest.isClose([x1,y1,x2,y2],image.width,image.height,this.config["THRESHOLDS"]["CLOSEST_THRESHOLD"]);
                    if (finded_ratio >= min_distance){
                        min_distance = finded_ratio;
                        closest_vehicle = item;
                        closest = closest_;
                    }
                });
                if (closest_vehicle != null){
                    vehicle_image = closest_vehicle.vehicle;
                }else{
                    this.hasError = true;
                    this.errorMessage = Errors.getMessage(Errors.NO_MOTOR);
                }
            }else{
                this.hasError = true;
                this.errorMessage = Errors.getMessage(Errors.NO_VALID_VEHICLE_TYPE);
            }
            if(!this.hasError){
                const [quality_output,quality_score,quality_error,quality_error_message] = await this.quality_detection.predict(vehicle_image,vehicleType);
                if (quality_error){
                    this.hasError = quality_error;
                    this.errorMessage = quality_error_message;
                }else{

                    if (quality_output == "good"){
                        res["isValidQuality"] = true;
                    }else{
                        res["isValidQuality"] = false;
                    }
                    res["score"] = quality_score;
                }
                res["isVaildVehicle"] = closest;
            }
        }
        res["hasError"] = this.hasError;
        res["errorMessage"] = this.errorMessage;

        window.tf.engine().endScope();

        return res;
  }
}